<div class="business-job-page">
    <!-- Slide-out Filter (mirrors new-job page) — hosts the full filter UI -->
    <app-jobs-candidates-slide-filter [valuesSentForFilters]="entitySent"
        (valuesRetainedForFilters)="onFilterToggle($event)">
        <app-job-filter-vertical-template *ngIf="panel == 'jobs'"
            [businessId]="businessData?.id"
            [filterChanges]="filterChanges"
            [jobFilterData]="filterConfig"
            [orgJobsMode]="true"
            [employeeListInput]="employeeList"
            [employeeLoadingInput]="employeeLoading"
            (employeeSearch)="onEmployeeSearch($event)"
            (employeeScroll)="onEmployeeScroll()"
            (myEmployeesToggled)="onMyEmployeesToggled()">
        </app-job-filter-vertical-template>
    </app-jobs-candidates-slide-filter>

    <!-- Header Controls Bar -->
    <div class="job-center-header-bar">
        <!-- Left Section: Selection Controls -->
        <div class="header-left-section">
            <button class="header-action-btn"
                [class.active]="selectionMode"
                (click)="toggleSelectionMode()"
                title="Toggle selection mode">
                <ng-icon [name]="selectionMode ? 'tablerSquareCheck' : 'tablerSquare'"></ng-icon>
                <span>{{ selectionMode ? 'Cancel' : 'Select' }}</span>
            </button>

            <div class="select-all-wrapper" *ngIf="selectionMode">
                <label class="custom-checkbox-wrapper">
                    <input type="checkbox" (change)="selecteAll($event)" [(ngModel)]="selecteAllFlag" />
                    <span class="custom-checkmark"></span>
                    <span class="checkbox-text">All</span>
                </label>
            </div>

            <button class="header-action-btn transfer-btn"
                [disabled]="countforEnable()==0"
                (click)="openModel(TransferRights)">
                <ng-icon name="tablerArrowsExchange"></ng-icon>
                <span>Transfer</span>
                <span class="count-badge" *ngIf="countforEnable() > 0">{{countforEnable()}}</span>
            </button>
        </div>

        <!-- Center Section: Search -->
        <div class="header-center-section">
            <div class="search-container">
                <ng-icon name="tablerSearch" class="search-icon"></ng-icon>
                <input type="text" class="search-input"
                    placeholder="Search by Creator name or Job Title"
                    [(ngModel)]="searchNameorEmail"
                    (input)="searchUsers()"
                    (keypress)="restrictSpecialChars($event)" />
            </div>
        </div>

        <!-- Right Section: All Filters (opens slide-out panel with the full filter set) -->
        <div class="header-right-section">
            <div class="all-filters" (click)="openFilterSlider()">
                <span>All Filters</span>
                <ng-icon name="tablerFilter"></ng-icon>
            </div>
            <div class="reset-filters" (click)="onResetFilters()">
                <span>Reset</span>
            </div>
        </div>
    </div>

    <!-- Scrollable Table Wrapper -->
    <div class="job-center-table-wrapper"
        infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="true"
        [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()">
        <!-- Hide column headers + horizontal-scroll container when empty so the
             empty state isn't cramped under the header row inside the
             max-content table layout. -->
        <div class="job-center-table-container" *ngIf="response.length > 0 || isLoading">

            <!-- Table Header -->
            <div class="job-center-table-header">
                <div class="header-cell owner-col">Owner</div>
                <div class="header-cell company-col">Company</div>
                <div class="header-cell job-location-col">Job & Location</div>
                <div class="header-cell skills-col">Skills</div>
                <div class="header-cell rate-col">Rate</div>
                <div class="header-cell engagement-col">Engagement</div>
                <div class="header-cell actions-col">Actions</div>
            </div>

            <!-- Loading Skeleton -->
            <div class="col-12" *ngIf="isLoading && userPayload.searchAfterKey==null && lastSearchAfterKey==null && response.length==0">
                <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
            </div>

            <!-- Job Rows -->
            <ng-container *ngIf="response.length > 0">
                <div class="job-center-table-body">
                    <ng-container *ngFor="let item of response; let i = index">
                        <app-job-card [showCheckBox]="selectionMode" (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"
                            [viewSize]="'customer-row-design'" [JobData]="item" [From]="'JOBS_FROM_PLATFORM'" [indexInput]="i" [hideAiInsights]="true"></app-job-card>
                    </ng-container>
                </div>

                <!-- Loading More Skeleton -->
                <app-common-skeleton *ngIf="isLoading && response.length!=0" [countforView]="2"
                    [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>

                <!-- Bottom Reached Message -->
                <div *ngIf="!scrollEnable && response?.length != 0" class="caught_up_business">
                    <div class="col-md-12 mg-bt-9">
                        <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
                    </div>
                    <div class="col-md-12">
                        <p class="biase">You've reached the bottom of the page</p>
                    </div>
                </div>
            </ng-container>

        </div>

        <!-- No Results — lifted out of .job-center-table-container so it spans
             the full wrapper width (table-container is width:max-content) and
             can vertically center cleanly. Pattern: job.component.html:1133-1136 -->
        <div class="jc-v3-list-empty" *ngIf="!isLoading && jobFoundStatus && response.length == 0">
            <ng-icon name="tablerSearch"></ng-icon>
            <p>{{ jobFoundStatus }}</p>
        </div>
    </div>

    <ng-template #TransferRights let-modal>
        <div class="common-header-flex">
            <div>Transfer Jobs</div>
            <button>
                <span (click)="closeModal()" class="common-close">&times;</span>
            </button>
        </div>
        <div class="modal-body SuperAdminModelDesign">
            <div class="container">
                <div class="col-sm-12">
                    <label for="q" class="col-sm-12 col-form-label label-fontview p-0"
                        style="margin-top: 6px; margin-left: -15px;">
                        Total Selected Job to Transfer : {{countforEnable()}}</label>
                </div>
                <label for="q" class="col-sm-2 col-form-label label-fontview p-0" style="margin-top: 6px;">Transfer To
                    :</label>
                <div class="col-sm-10">
                    <ng-select [multiple]="false" [items]="userList" [hideSelected]="false" [closeOnSelect]="true"
                        [(ngModel)]="selectedUser" name="licenseAuthorityId" bindValue="userId" bindLabel="fullName"
                        placeholder="Select User" (change)="onSelectionChange($event)"
                        [disableItemFn]="isItemDisabled" class="user-d gs-clear-plain" appendTo=".gs-transfer-modal">

                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="custom-control custom-radio flex user-dropdown"  [class.disabled]="item.disabled"  (click)="selectUser(item)">
                                <img *ngIf="item.photo" class="img-show-hide" [src]="url + item.photo">
                                <div *ngIf="!item.photo">
                                    <div class="circleimg-show-hide"
                                        [style.background-color]="getColortwo(item.firstName, item.lastName)">
                                        <div class="circle-text">{{ getInitialstwo(item.firstName, item.lastName) }}
                                        </div>
                                    </div>
                                </div>
                                <label class="form-radio-label ml-2 custom-control-label">
                                    {{ item.fullName }}
                                </label>
                            </div>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="showError" class="text-danger">Please select a user.</div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="closeModal()"> Cancel
            </button>
            <button type="button" class="btn btn-primary" [disabled]="selectedUser==null"
                (click)="TransferUser()"> Transfer
            </button>
        </div>
    </ng-template>
</div>
